import React from 'react'
import { cn } from '@/common/utils/utils'

export interface Props extends React.LabelHTMLAttributes<HTMLLabelElement> {
    label?: string
}

export const Label = ({ className, children, htmlFor, ...props }: Props) => {
    return (
        <label htmlFor={htmlFor} className={cn('text-sm mb-1', className)} {...props}>
            {children}
        </label>
    )
}
